import { FetcherAmplify } from 'src/business/Libraries/Fetcher/FetcherAmplify';
import { Campaign, Referral } from '../domain/Campaign';
import { ParticipantI } from '../domain/Participant';
import ReferralRepositoryI from './ReferralRepositoryI';

export default class ReferralRepositoryImpl implements ReferralRepositoryI {
  constructor(private fetcher: FetcherAmplify) {}

  public async findCampaigns(customerId: string): Promise<Campaign[]> {
    const campaigns = await this.fetcher.get(
      `/v1/customers/${customerId}/campaigns`,
    );
    return campaigns.map((c) => ({
      id: c.id,
      name: c.name,
      type: c.type,
      endDate: c.endDate,
      isActive: c.endDate > Date.now(),
    }));
  }

  public async createParticipant(
    campaignId: string,
    customerId: string,
  ): Promise<ParticipantI> {
    const response = await this.fetcher.post(
      `/v1/campaigns/${campaignId}/participants?customerId=${customerId}`,
    );
    return {
      id: response?.id,
      referralsCount: response?.referralsCount,
      cumulativeReward: response?.cumulativeReward,
      creationDate: response?.creationDate,
      customId: response?.customId,
    };
  }

  public async findParticipantById(
    campaignId: string,
    customerId: string,
  ): Promise<ParticipantI> {
    const response = await this.fetcher.get(
      `/v1/campaigns/${campaignId}/participants/customers/${customerId}`,
    );

    return {
      id: response?.id,
      referralsCount: response?.referralsCount,
      cumulativeReward: response?.cumulativeReward,
      customId: response?.customId,
      campaign: response?.campaign,
      creationDate: response?.creationDate,
    };
  }

  public async findReferralsByParticipantId(
    campaignId: string,
    participantId: string,
  ): Promise<Referral[]> {
    const response = await this.fetcher.get(
      `/v1/campaigns/${campaignId}/participants/${participantId}/referrals`,
    );

    return response.map((r) => ({
      id: r.id,
      _displayName: r._displayName,
      __displayDate: r._displayDate,
    }));
  }
}
